import React from 'react';
import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

interface DetailItem {
  title?: string;
  titleDescription?: string;
  pointsubTitle?: string;
  listPoints?: string[];
  endDiscussion?: string;
  hoverlink?: string;
}

const DetailSection: React.FC<{ detail: DetailItem }> = ({ detail }) => {
  if (!detail) return null;
  return (
    <Box sx={{ mb: 2 }}>
      {/* Title */}
      {detail.title && (
        <Typography variant="h6" color="#000" gutterBottom textAlign="start">
          {detail.title}
        </Typography>
      )}

      {/* Title Description */}
      {detail.titleDescription && (
        <Typography variant="body2" color="#000" gutterBottom textAlign="start" sx={{'& b': { color: '#0f63a5', fontWeight: 700 } }}
          dangerouslySetInnerHTML={{ __html: detail.titleDescription }}
          
        //   {detail.titleDescription}
        />
      )}

      {/* Point Sub Title */}
      {detail.pointsubTitle && (
        <Typography variant="body2" color="#000" fontWeight={600} textAlign="start" sx={{ mt: 1,  }}>
          {detail.pointsubTitle}
        </Typography>
      )}

      {/* List Points */}
      {detail.listPoints && detail.listPoints.length > 0 && (
        <Box component="ul" sx={{ textAlign: 'start', color: '#000', mt: 2, listStyleType: 'disc', pl: 2 }}>
          {detail.listPoints.map((point, i) => (
            <Typography
              key={i}
              component="li"
              variant="body2"
              color="#000"
              sx={{ listStyleType: 'disc', '&::marker': { color: 'primary.main' }, mb: 1, '& b': { color: '#0f63a5', fontWeight: 700 } }}
              dangerouslySetInnerHTML={{ __html: point }}
            />
          ))}
        </Box>
      )}

      {/* End Discussion */}
      {detail.endDiscussion && (
        <Typography
          variant="body2"
          color="#000"
          textAlign="start"
          sx={{ mt: 2, mb: 2, '& b': { color: '#0f63a5', fontWeight: 700 } }}
          dangerouslySetInnerHTML={{ __html: detail.endDiscussion }}
        />
      )}

      {/* Hover Link */}
      {detail.hoverlink && (
        <Link to="/contact" style={{ textDecoration: 'none' }}>
          <Typography
            variant="body2"
            sx={{
              color: '#0f63a5',
              fontWeight: 600,
              textAlign: 'start',
              mt: 1,
              mb: 3,
              cursor: 'pointer',
              '& b': { color: '#0f63a5', fontWeight: 700 },
            }}
            dangerouslySetInnerHTML={{ __html: detail.hoverlink }}
          />
        </Link>
      )}
    </Box>
  );
};

export default DetailSection;
